import React from 'react';

/**
 *
 * 3 animated loading dots with an optional suffix sentance
 *
 * @param { string } textSuffix string to be added before loading dots
 *
 */
function TextLoadingDots({ textSuffix }) {
  return (
    <div className="c-text-loading-dots">
      {textSuffix || null}
      <span className="dot one">.</span>
      <span className="dot two">.</span>
      <span className="dot three">.</span>
    </div>
  );
}

export default TextLoadingDots;



// WEBPACK FOOTER //
// ./src/layout/graphics/TextLoadingDots.js